import React, { useEffect } from "react";
import { useFormik } from "formik";
import ModalElement from "../Modal";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import SaveIcon from '@mui/icons-material/Save';
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";

const revenueModels = [
    { name: "Recurring", value: "subscription" },
    { name: "Transactional", value: "transactional" },
];

export default function RevenueModelModal({
    revenue_model,
    driver_analysis,
    onSubmit,
}) {
    // Show only if revenue_model is null/undefined and any driver of interest exists
    const needsRevenueModel = React.useMemo(() => {
        if (revenue_model != null) return false;
        const keySet = new Set(["revenue_loss", "operational_costs"]);
        // driver_analysis is an object like { cost_savings: [...], extra_costs: [...], ... }
        return Object.values(driver_analysis || {}).some((sectionArray) =>
            Array.isArray(sectionArray) &&
            sectionArray.some((section) =>
                section.drivers?.some((d) => keySet.has(d.driver))
            )
        );
    }, [revenue_model, driver_analysis]);

    const formik = useFormik({
        initialValues: { revenue_model: "" },
        onSubmit: onSubmit,
    });

    useEffect(() => {
        if (needsRevenueModel) {
            formik.resetForm();
        }
        // only when modal visibility changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needsRevenueModel]);

    if (!needsRevenueModel) return null;

    return (
        <ModalElement
            modalOpen={true}
            handleClose={() => { }}
            header="Select revenue model"
            instruction="Please choose your customers’ revenue model to continue."
            noClose={true}
            content={
                <Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 1 }}>
                    <Select
                        name="revenue_model"
                        value={formik.values.revenue_model}
                        onChange={formik.handleChange}
                        displayEmpty
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="" disabled>
                            Select revenue model
                        </MenuItem>
                        {revenueModels.map((r) => (
                            <MenuItem key={r.value} value={r.value}>
                                {r.name}
                            </MenuItem>
                        ))}
                    </Select>

                    <Box sx={{ textAlign: "right", mt: 2 }}>
                        <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            color="primary"
                            type="submit"
                            disabled={!formik.values.revenue_model}
                            size="small"
                            sx={{textTransform: 'none'}}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            }

        />

    );
}